import { useAuth0 } from '@auth0/auth0-react';
import SaveIcon from '@mui/icons-material/Save';
import LoadingButton from '@mui/lab/LoadingButton';
import {
    Grid,
    LinearProgress,
    Modal,
    Stack,
    styled,
    TextField,
    Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Prompt } from 'react-router';
import approvalImage from '../../assets/approvalImage.png';
import { getSchoolTeachers, updateSchool } from '../../redux/SchoolSlice';
import InputImageModal from '../BasicComponents/InputImageModal';
import LimitedTextField from '../BasicComponents/LimitedTextField';
import TeacherMultiDropDown from '../CustomDropDown/TeacherMultiDropDown';
import UploadSection from './UploadSection';

const IconImage = styled('img')(({ theme }) => ({
    width: '100px',
    height: 'auto',
    borderRadius: '5%',
    textAlign: 'center',
}));

const Image = styled('img')(({ theme }) => ({
    borderRadius: '20%',
    boxShadow: '0 0 25px 0 #b3bac7',
    width: 150,
    margin: 'auto',
}));

const GeneralText = styled(TextField)(({ theme }) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginLeft: '0.5%',
    marginRight: '0.5%',
    width: '48%',
}));

const BookingButton = styled(LoadingButton)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px auto',
    width: '100%',
    maxWidth: '250px',
    borderRadius: '30px',
}));
// const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
export const SchoolInfo = props => {
    const { getAccessTokenSilently } = useAuth0();
    const dispatch = useDispatch();

    const teachersInSchoolStatus = useSelector(
        state => state.school.getTeacherStatus
    );

    const [state, setState] = useState({
        schoolImageURL: {
            value: props.school.school.Data['schoolLogo'],
            touched: false,
            error: false,
            errorCode: '',
        },
        displayName: {
            value: props.school.school.Data.displayName,
            touched: false,
            error: false,
            errorCode: '',
        },
        schoolAddress: {
            value: props.school.school.Data.address,
            touched: false,
            error: false,
            errorCode: '',
        },
        schoolLatLng: {
            lat: props.school.school.Data.lat,
            lng: props.school.school.Data.lng,
        },
        schoolDescription: {
            value: props.school.school.Data.description,
            touched: false,
            error: false,
            errorCode: '',
        },
        contacts: {
            value: [],
            touched: false,
            error: false,
            errorCode: '',
        },
        submitError: false,
        loadingImage: false,
    });
    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        async function propsToState() {
            var contacts = [];
            if (typeof props.school.school.Data.contacts !== 'undefined') {
                try {
                    contacts = props.school.school.Data.contacts.map(
                        contact => {
                            const uniqueIdToPk1 =
                                props.school.teachersInSchool.Data.find(
                                    teacherItem =>
                                        teacherItem.uniqueId ===
                                        contact.uniqueId
                                );
                            return uniqueIdToPk1.pk1;
                        }
                    );
                } catch (err) {
                    console.log('err', err);
                }
            }
            setState({
                ...state,
                schoolImageURL: {
                    value: props.school.school.Data['schoolLogo'],
                    touched: false,
                    error: false,
                    errorCode: '',
                },
                displayName: {
                    value: props.school.school.Data.displayName,
                    touched: false,
                    error: false,
                    errorCode: '',
                },
                schoolAddress: {
                    value: props.school.school.Data.address,
                    touched: false,
                    error: false,
                    errorCode: '',
                },
                schoolLatLng: {
                    lat: props.school.school.Data.lat,
                    lng: props.school.school.Data.lng,
                },
                schoolDescription: {
                    value: props.school.school.Data.description,
                    touched: false,
                    error: false,
                    errorCode: '',
                },
                contacts: {
                    value: contacts,
                    touched: false,
                    error: false,
                    errorCode: '',
                },
            });
        }
        propsToState();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.school]);
    function handleChange(event) {
        let tempSchoolItem = state[event.target.id];
        tempSchoolItem = {
            value: event.target.value,
            touched: true,
            error: tempSchoolItem.error,
            errorCode: tempSchoolItem.errorCode,
        };
        setState({
            ...state,
            [event.target.id]: tempSchoolItem,
        });
    }

    const handleContactSelect = value => {
        setState({
            ...state,
            contacts: {
                touched: true,
                value: value,
                error: false,
                errorCode: '',
            },
        });
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    let callback = imageURL => {
        //setImageURL(imageURL)
        var itemStruct = {
            value: imageURL,
            touched: true,
            error: false,
            errorCode: '',
        };
        setState({
            ...state,
            loadingImage: true,
        });
        setTimeout(() => {
            setState({
                ...state,
                schoolImageURL: itemStruct,
                loadingImage: false,
            });
        }, 2000);
        handleClose();
    };
    /******************
     * Perform on load
     ******************/

    useEffect(() => {
        console.log('school redux', props.school);
        if (teachersInSchoolStatus === 'idle') {
            async function dispatchSchoolTeachersFromStore() {
                const token = await getAccessTokenSilently({
                    scope: process.env.REACT_APP_scope,
                });
                const requestData = {
                    'token': token,
                };

                //doesnt seem to work on Safari - need to troubleshoot
                dispatch(getSchoolTeachers(requestData));
            }
            dispatchSchoolTeachersFromStore();
        }
        console.log('school info', JSON.stringify(props.school));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [teachersInSchoolStatus]);

    const saveSchool = async () => {
        function resetTouchedItems() {
            let schoolImageURL = state.schoolImageURL;
            let description = state.schoolDescription;
            let displayName = state.displayName;
            let contacts = state.contacts;
            schoolImageURL.touched = false;
            contacts.touched = false;
            description.touched = false;
            displayName.touched = false;
            setState({
                ...state,
                contacts: contacts,
                schoolDescription: description,
                schoolImageURL: schoolImageURL,
                displayName: displayName,
            });
        }

        try {
            setLoading(true);
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });
            var updateList = [];
            if (state.schoolImageURL.touched === true) {
                updateList.push({
                    'key': 'schoolLogo',
                    'value': state.schoolImageURL.value,
                });
            }
            if (state.displayName.touched === true) {
                updateList.push({
                    'key': 'displayName',
                    'value': state.displayName.value,
                });
            }
            if (state.contacts.touched === true) {
                updateList.push({
                    'key': 'contacts',
                    'value': state.contacts.value,
                });
            }
            if (state.schoolDescription.touched === true) {
                updateList.push({
                    'key': 'description',
                    'value': state.schoolDescription.value,
                });
            }
            let dynamoData = {
                token: token,
                request: {
                    'updateList': updateList,
                },
            };

            const generalResponse = await dispatch(updateSchool(dynamoData));
            console.log('general response', JSON.stringify(generalResponse));

            if (typeof generalResponse.meta.requestStatus !== 'undefined') {
                if (generalResponse.meta.requestStatus === 'fulfilled') {
                    props.setNotif(
                        'success',
                        6000,
                        'School information updated'
                    );
                    resetTouchedItems();
                } else {
                    props.setNotif(
                        'error',
                        0,
                        'Error updating your school information'
                    );
                }
            } else {
                props.setNotif(
                    'error',
                    0,
                    'Error updating your school information'
                );
            }
            setLoading(false);
        } catch (err) {
            console.log('Error occurred updating school');
            setState({
                ...state,
                apiMessage: 'Error occurred updating school',
            });
            setLoading(false);
        }
    };

    return (
        <Grid
            container
            xs={12}
            sx={{ justifyContent: 'center', alignItems: 'center' }}
        >
            <Prompt
                when={
                    state.schoolDescription.touched === true ||
                    state.contacts.touched === true ||
                    state.displayName.touched === true ||
                    state.schoolImageURL.touched === true
                }
                message="There are unsaved changes. Are you sure you want to leave?"
            />
            {typeof props.school.school.Data.displayName !== 'undefined' ? (
                <>
                    <Grid
                        item
                        md="150px"
                        sx={{
                            padding: '0 20px 0 0',
                        }}
                    >
                        {props.schoolAdmin ? (
                            <Image
                                src={state.schoolImageURL.value}
                                onClick={handleOpen}
                                alt="School Logo"
                            />
                        ) : (
                            <Image
                                src={state.schoolImageURL.value}
                                alt="School Logo"
                            />
                        )}

                        {state.loadingImage && <LinearProgress sx={{ m: 1 }} />}
                    </Grid>

                    <Grid
                        item
                        md
                        sx={{
                            margin: 'auto',
                            width: '100%',
                        }}
                    >
                        <GeneralText
                            label="School Name"
                            data-cy="school-name"
                            id="displayName"
                            variant="outlined"
                            onChange={handleChange}
                            value={state.displayName.value}
                            disabled
                        />
                        <GeneralText
                            label="Address"
                            id="schoolAddress"
                            variant="outlined"
                            onChange={handleChange}
                            value={state.schoolAddress.value}
                            disabled
                        />
                        <LimitedTextField
                            disabled={!props.schoolAdmin}
                            label="schoolDescription"
                            value={state.schoolDescription.value}
                            updateField={handleChange}
                            width="97%"
                            textLength={500}
                        />

                        {typeof props.school.teachersInSchool.Data !==
                            'undefined' &&
                            props.schoolAdmin && (
                                <div>
                                    <TeacherMultiDropDown
                                        id="schoolContacts"
                                        selectedTeachers={state.contacts.value}
                                        teachers={
                                            props.school.teachersInSchool.Data
                                        }
                                        handleSelect={handleContactSelect}
                                        subtitle="Select Contacts"
                                        title="School Main Contacts: "
                                        compareValue="pk1"
                                        loadingStatus={teachersInSchoolStatus}
                                    />
                                </div>
                            )}
                        {props.schoolAdmin && (
                            <BookingButton
                                sx={{ maxWidth: '150px' }}
                                id="profileSave"
                                size="large"
                                color="primary"
                                onClick={saveSchool}
                                loading={loading}
                                loadingPosition="start"
                                startIcon={<SaveIcon />}
                                variant="outlined"
                                disabled={
                                    !(
                                        state.schoolImageURL.touched ||
                                        state.schoolDescription.touched ||
                                        state.contacts.touched
                                    )
                                }
                            >
                                Save
                            </BookingButton>
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        <UploadSection
                            setSnackBar={props.setSnackBar}
                            setNotif={props.setNotif}
                            type="school"
                        />
                    </Grid>
                </>
            ) : (
                <Stack direction="column" sx={{ alignItems: 'center' }}>
                    <Typography
                        variant="h6"
                        sx={{ padding: '20px' }}
                        data-cy="awaiting-approval"
                    >{`School awaiting verification and approval`}</Typography>
                    <Typography
                        variant="body"
                        sx={{ padding: '20px' }}
                    >{`You will receive an email when your school has been approved for airTeachr`}</Typography>
                    <IconImage
                        src={approvalImage}
                        sx={{ marginBottom: '20px' }}
                    />
                </Stack>
            )}

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="Modal-Profile-Image"
                aria-describedby="Open-Modal-For-Upload"
            >
                <InputImageModal parentCallback={callback} text="School Logo" />
            </Modal>
        </Grid>
    );
};

export default SchoolInfo;
